import { render, staticRenderFns } from "./atcd-historique-allergologie-familiaux.html?vue&type=template&id=30943312&scoped=true&external"
import script from "./atcd-historique-allergologie-familiaux.js?vue&type=script&lang=js&external"
export * from "./atcd-historique-allergologie-familiaux.js?vue&type=script&lang=js&external"
import style0 from "./atcd-historique-allergologie-familiaux.scss?vue&type=style&index=0&id=30943312&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30943312",
  null
  
)

export default component.exports